import styled from 'styled-components'
import { colors } from 'client/styles'

export const FilterCategoryBase = styled.div`
  padding-block: 15px;
  padding-inline: 20px;
`

export const Title = styled.h3`
  color: ${colors.grey1};
  font-weight: 700;
  margin-block-end: 1em;
`

export const List = styled.ul`
  display: flex;
  flex-direction: column;

  > li {
    margin-inline-end: 0.25em;
    svg.star-icon {
      margin-block: 0;
      margin-inline: 4px 0;
    }
  }
`
